<div id="classes" class="about-area pt-100 pb-70">
    <div class="container">
        <div class="row">
        <div class="section-title col-lg-4 col-sm-12 text-left d-flex align-items-center ml-0">
            <div class="mb-4">
                <h2 [innerHTML]="classesConfig.title | linebreaks"></h2>
                <p [innerHTML]="classesConfig.description | linebreaks"></p>
                <a [href]="classesConfig.buttonUrl" class="btn btn-primary rounded-pill px-4 py-2 rounded-pill-btn">
                    {{ classesConfig.buttonText }}
                </a>
            </div>
        </div>
        <div class="section-title col-lg-8 col-sm-12">
            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column about">
                    <ng-container *ngFor="let tile of classesConfig.tiles.slice(0,2)">
                        <div class="about-image" [style.backgroundImage]="'url(' + tile.tileImage + ')'">
                            <button class="video-btn" *ngIf="tile.video.show" (click)="ngxSmartModalService.getModal(tile.video.modalId).open()">
                                <i class="fa-solid fa-play"></i>
                            </button>
                            <div class="logo" [style.backgroundImage]="'url(' + tile.overlayImage + ')'"></div>
                        </div>
                        <div class="about-descr">
                            <div class="about-title">{{tile.title}}</div>
                            {{tile.description}}
                        </div>
                    </ng-container>
                    <div class="about-space"></div>
                </div>
                <div class="about-spacer">&nbsp;</div>
                <div class="d-flex flex-column about">
                    <div class="about-space"></div>
                    <ng-container *ngFor="let tile of classesConfig.tiles.slice(2,4)">
                        <div class="about-image" [style.backgroundImage]="'url(' + tile.tileImage + ')'">
                            <button class="video-btn" *ngIf="tile.video.show" (click)="ngxSmartModalService.getModal(tile.video.modalId).open()">
                                <i class="fa-solid fa-play"></i>
                            </button>
                            <div class="logo" [style.backgroundImage]="'url(' + tile.overlayImage + ')'"></div>
                        </div>
                        <div class="about-descr">
                            <div class="about-title">{{tile.title}}</div>
                            {{tile.description}}
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Video Popup -->
<div class="video-popup">
    <ng-container *ngFor="let tile of classesConfig.tiles">
        <ngx-smart-modal *ngIf="tile.video.show && tile.video.modalId" #[tile.video.modalId]="" [identifier]="tile.video.modalId" (onOpen)="tile.video.show=true">
            <video *ngIf="tile.video.show" controls>
            <source [src]="tile.video.videoUrl" type="video/mp4">
            </video>
        </ngx-smart-modal>
    </ng-container>
</div>